export default "__VITE_ASSET__CZZH41rw__"